// src/components/resume/ResumeEducation.js
import React from 'react';
import styles from '../../styles/pages/Resume.module.css';

/**
 * Resume education item component for displaying educational background
 * 
 * @param {Object} props - Component props
 * @param {string} props.degree - Degree name
 * @param {string} props.institution - Educational institution
 * @param {string} props.period - Study period
 */
export function ResumeEducation({ 
  degree, 
  institution, 
  period 
}) {
  return (
    <>
      <h3 className={styles.cardTitle}>{degree}</h3>
      <p>
        <em>{institution}</em>
        <br />
        {period}
      </p>
    </>
  );
}